module.exports = __webpack_public_path__ + "static/media/thoracicSpine-quizz.ba2d40e6.jpg";